import { NotificationService } from '@fluidx/office-fluid-types';

/**
 * A service to handle notifications when a user is at mentioned
 */
export class AppNotificationService implements NotificationService {
    constructor(private readonly onAtMention: (address: string) => void) {}

    public get NotificationService() {
        return this;
    }

    public async notifyAtMention(
        _recipientUpn: string,
        _contentId: string,
        _navigationPath: string
    ): Promise<boolean> {
        if (_recipientUpn?.length > 0) {
            this.onAtMention(_recipientUpn);
            return true;
        }
        return false;
    }
}
